import { render, staticRenderFns } from "./ViewPostPrivate.vue?vue&type=template&id=4cc14b4c&"
import script from "./ViewPostPrivate.vue?vue&type=script&lang=js&"
export * from "./ViewPostPrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports